import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { getCookie } from '@shared/shared.utils'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import Validator from '@shared/validatorjs/src/validator'

import { Language } from './store/i18n.interface'
import { getAvaliableLanguagesState } from './store/i18n.selector'

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly LANGUAGE_COOKIE_NAME = 'lang'

  constructor(
    private translateService: TranslateService,
    private store: Store<Observable<any>>,
  ) {}

  getAvaliableLanguages(): Observable<Array<Language>> {
    return this.store.pipe(
      select(getAvaliableLanguagesState),
      map((state) => state.toJS()),
      filter((state) => state.length),
    )
  }

  activateLanguage(lang: Language) {
    this.translateService.use(lang.iso2code)
    Validator.useLang(lang.iso2code)
    this.setLangToCookie(lang)
  }

  detectLanguage(): string {
    return getCookie(this.LANGUAGE_COOKIE_NAME)
  }

  setLangToCookie(lang: Language) {
    document.cookie = `${this.LANGUAGE_COOKIE_NAME}=${lang.iso2code}; path=/;`
  }
}
